
<kendo-formfield>
    <kendo-label [text]="caption | translate"></kendo-label>
    <kendo-maskedtextbox
    [ngClass]="{'fx-fill': settings.fxFill}"  
    [formControl]="control" 
    (valueChange)="onChange($event)"
    [mask]="settings.format"
    [maskValidation]="true"
    [includeLiterals]="false"
    > </kendo-maskedtextbox>
</kendo-formfield>


